import { ModalBackground, ModalCard } from "../hometab/styles";
import SubmitButton from "../../atoms/submitbutton";
import { useState } from "react";
import facebook from "../../../assets/images/Facebook.svg";
import TwitterX from "../../../assets/images/TwitterX.svg";
import Pinterest from "../../../assets/images/Pinterest.svg";
import YouTube from "../../../assets/images/YouTube.svg";
import Instagram from "../../../assets/images/Instagram.svg";
import LinkedIn from "../../../assets/images/LinkedIn.svg";
import { Heading, Info, Form, InputContainer, SocialIcon, Input, SubmitContainer } from "./styles";

import { yupResolver } from "@hookform/resolvers/yup";
import { useSelector } from "react-redux";
import * as yup from "yup";
import { toast } from "react-toastify";
import axios from "axios";
import { API_URL } from "../../../constants";
import { useForm } from "react-hook-form";
import { socialsSchema } from "../../../validations/socials";

type FormData = yup.InferType<typeof socialsSchema>;

interface SocialProps {
  toggleClear: () => void;
  socials: any;
  refresh: boolean;
  setRefresh: any;
}
export function SocialModal({ toggleClear, socials, refresh, setRefresh }: SocialProps) {
  const [isloading, setisloading] = useState(false);
  let businessUuid = useSelector((state: any) => state.auth.uuid);

  const { register, handleSubmit, formState, reset } = useForm<FormData>({
    resolver: yupResolver(socialsSchema),
    defaultValues: {
      facebook: socials?.facebook,
      twitter: socials?.twitter,
      pinterest: socials?.pinterest,
      instagram: socials?.instagram,
      youtube: socials?.youtube,
      linkedin: socials?.linkedin,
    },
  });
  const { errors } = formState;

  const createRequest = (data: any) => {
    setisloading(true);

    let facebookUrl = null;
    let twitterUrl = null;
    let pinterestUrl = null;
    let instagramUrl = null;
    let youtubeUrl = null;
    let linkedinUrl = null;

    if (!data?.facebook) {
      facebookUrl = null;
    } else {
      let testUrl = /https?:\/\//i.test(data?.facebook); // Check for "http" or "https"
      if (testUrl) {
        facebookUrl = data.facebook;
      } else {
        facebookUrl = `https://${data.facebook}`;
      }
    }

    if (!data?.twitter) {
      twitterUrl = null;
    } else {
      let testUrl = /https?:\/\//i.test(data?.twitter); // Check for "http" or "https"
      if (testUrl) {
        twitterUrl = data.twitter;
      } else {
        twitterUrl = `https://${data.twitter}`;
      }
    }

    if (!data?.pinterest) {
      pinterestUrl = null;
    } else {
      let testUrl = /https?:\/\//i.test(data?.pinterest); // Check for "http" or "https"
      if (testUrl) {
        pinterestUrl = data.pinterest;
      } else {
        pinterestUrl = `https://${data.pinterest}`;
      }
    }

    if (!data?.instagram) {
      instagramUrl = null;
    } else {
      let testUrl = /https?:\/\//i.test(data?.instagram); // Check for "http" or "https"
      if (testUrl) {
        instagramUrl = data.instagram;
      } else {
        instagramUrl = `https://${data.instagram}`;
      }
    }

    if (!data?.youtube) {
      youtubeUrl = null;
    } else {
      let testUrl = /https?:\/\//i.test(data?.youtube); // Check for "http" or "https"
      if (testUrl) {
        youtubeUrl = data.youtube;
      } else {
        youtubeUrl = `https://${data.youtube}`;
      }
    }

    if (!data?.linkedin) {
      linkedinUrl = null;
    } else {
      let testUrl = /https?:\/\//i.test(data?.linkedin); // Check for "http" or "https"
      if (testUrl) {
        linkedinUrl = data.linkedin;
      } else {
        linkedinUrl = `https://${data.linkedin}`;
      }
    }

    let formData: any = {
      businessUuid: businessUuid,
      facebook: facebookUrl,
      twitter: twitterUrl,
      pinterest: pinterestUrl,
      instagram: instagramUrl,
      youtube: youtubeUrl,
      linkedin: linkedinUrl,
    };
    axios
      .post(`${API_URL}/update/socials`, formData)
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          setisloading(false);
          toast.success(response.data.message);
          reset();
          toggleClear();
          setRefresh(!refresh);
        }
      })
      .catch((error) => {
        setisloading(false);

        if (error?.response?.status === 400 || error?.response?.status === 401) {
          toast.error(error?.response?.data?.message);
          return;
        }
        toast.error("Connection Failed");
      });
  };

  return (
    <ModalBackground onClick={toggleClear}>
      <ModalCard onClick={(event) => event.stopPropagation()}>
        <form onSubmit={handleSubmit(createRequest)}>
          <Heading>Social Media Information</Heading>
          <Info>Paste the URLs of your Social Media Pages</Info>
          <Form>
            <InputContainer>
              <SocialIcon src={facebook} alt="facebook Icon" />
              <Input type="text" placeholder="https://www.facebook.com" {...register("facebook")} />
              {errors?.facebook && <p className="text-xs mb-2 text-red-600">{errors.facebook?.message}</p>}
            </InputContainer>
            <InputContainer>
              <SocialIcon src={TwitterX} alt="Twitter Icon" />
              <Input type="text" placeholder="https://www.twitter.com" {...register("twitter")} />
              {errors?.twitter && <p className="text-xs mb-2 text-red-600">{errors.twitter?.message}</p>}
            </InputContainer>

            <InputContainer>
              <SocialIcon src={Pinterest} alt="Pinterest Icon" />
              <Input type="text" placeholder="https://www.pinterest.com" {...register("pinterest")} />
              {errors?.pinterest && <p className="text-xs mb-2 text-red-600">{errors.pinterest?.message}</p>}
            </InputContainer>

            <InputContainer>
              <SocialIcon src={YouTube} alt="YouTube Icon" />
              <Input type="text" placeholder="https://www.youtube.com" {...register("youtube")} />
              {errors?.youtube && <p className="text-xs mb-2 text-red-600">{errors.youtube?.message}</p>}
            </InputContainer>

            <InputContainer>
              <SocialIcon src={Instagram} alt="Instagram Icon" />
              <Input type="text" placeholder="https://www.instagram.com" {...register("instagram")} />
              {errors?.instagram && <p className="text-xs mb-2 text-red-600">{errors.instagram?.message}</p>}
            </InputContainer>

            <InputContainer>
              <SocialIcon src={LinkedIn} alt="LinkedIn Icon" />
              <Input type="text" placeholder="https://www.linkedin.com" {...register("linkedin")} />
              {errors?.linkedin && <p className="text-xs mb-2 text-red-600">{errors.linkedin?.message}</p>}
            </InputContainer>
            <SubmitContainer>
              <SubmitButton isloading={isloading} value="Save" width="19.6em" />
            </SubmitContainer>
          </Form>
        </form>
      </ModalCard>
    </ModalBackground>
  );
}
